// extracted by mini-css-extract-plugin
module.exports = {"headerButtons":"Profile_headerButtons__14_Je","icon":"Profile_icon__2ZVzZ"};